export const isServerSide = (): boolean => globalThis.__RENDER_LOCATION__ === "server";
